import styled from 'styled-components';

import { TextButton as TextButtonComponent } from '@xingternal/button';
import { mediaConfined } from '@xingternal/layout-tokens';
import { spaceL, spaceS } from '@xingternal/tokens';

import { SortingButton as SortingButtonComponent } from './buttons';

export const Container = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: ${spaceL};

  @media ${mediaConfined} {
    margin-top: 48px;
    margin-bottom: ${spaceL};
  }
`;

export const TextButton = styled(TextButtonComponent)`
  flex-shrink: 0;
  margin-left: ${spaceS};
`;

export const Buttons = styled.div`
  flex-shrink: 0;
  margin-left: ${spaceS};
`;

export const SortingButton = styled(SortingButtonComponent)`
  margin-left: ${spaceS};
`;
